import Button from "@/components/ui/button";
import { track } from "@/features/analytics";
import { useDeleteMediaFolderMutation } from "@api/media-folders";
import Spinner from "@components/ui/spinner";
import { cn } from "@lib/cn";
import { useAppDispatch } from "@store";
import { closeDialog } from "@store/dialogs";
import { toast } from "react-toastify";
import { MediaLibDialogBase } from "../../media-lib-dialog-base";

const DIALOG_ID = "media-lib-folder-delete";

interface IProps {
  folderId: string;
  folderName: string;
}

export const MediaLibFolderDeleteDialog = ({
  folderId,
  folderName,
}: IProps) => {
  const dispatch = useAppDispatch();

  const [deleteFolder, { isLoading }] = useDeleteMediaFolderMutation();

  const handleClose = () => {
    dispatch(closeDialog(DIALOG_ID));
  };

  const handleSubmit = async () => {
    if (isLoading) return;

    try {
      await deleteFolder({
        id: folderId,
      }).unwrap();
    } catch (e) {
      track("error deleting media folder", {
        folderId,
        error: e,
      });
      toast.error("Error deleting folder");
    }

    handleClose();
  };

  return (
    <MediaLibDialogBase>
      <MediaLibDialogBase.Header title="Delete folder" onClose={handleClose} />
      <MediaLibDialogBase.Content>
        <p className="tw-text-[13px]">
          Are you sure that you want to delete{" "}
          <b className="tw-font-semibold">“{folderName}”</b> folder with  all of
          its contents?
        </p>
      </MediaLibDialogBase.Content>
      <MediaLibDialogBase.Footer>
        <Button variant="secondary" className="tw-mr-4" onClick={handleClose}>
          Go back
        </Button>
        <Button
          variant="destructive"
          onClick={handleSubmit}
          className={cn(isLoading && "tw-cursor-not-allowed")}
        >
          {isLoading ? (
            <>
              <Spinner className="tw-mr-2 tw-size-3 tw-border-white" />
              Deleting...
            </>
          ) : (
            "Yes, delete"
          )}
        </Button>
      </MediaLibDialogBase.Footer>
    </MediaLibDialogBase>
  );
};

MediaLibFolderDeleteDialog.dialogId = DIALOG_ID;
